/**
 * defa.views.RecipientGroupCreateForm
 * A Form for creating a new RecipientGroup.
 * @version 1.0.0
 */

import { defa } from '../../../defa-object';
import Form     from '../../poppet/form';
import template from '../notifications/template-recipientGroup-create-form.jst.html';

const selectors = {
	inputName : '[data-input=recipient-name]',
};

const channelNav = Bb.Radio.channel( 'nav' );


export const RecipientGroupCreateForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template,
	noInitValidation: true,
	ui: {
		inputName : selectors.inputName,
	},


	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	/**
	 * Validates the name input field
	 * Triggers when the user inputs something into the name input field.
	 * @void
	 */
	validate: function(){
		let currentName = this.ui.inputName.val().trim();
		return currentName !== '' && currentName !== this.model.get('name');
	},
	
	/**
	 * Triggers when a user clicks the save button.
	 * Submits the form.
	 * @void
	 */
	submit() {
		let form = {
			name : this.ui.inputName.val().trim(),
		};
		this.model.set( form );
		this.saveModel();
		
	},
	
	/**
	 * Saves the RecipientGroup model to backend.
	 * @void
	 */
	saveModel: function () {
		let self = this;
		self.busy();
		try {
			self.model.save( {}, {
				success: function () {
					console.log( 'RecipientGroup Model was saved!' );
					self.idle();
				},
				error  : function () {
					alert( 'ERROR! failed syncing' );
					console.error( 'RecipientGroup Model failed at saving...' );
					self.idle();
					
				}
			} );
		} catch ( err ) {
			alert( 'Failed syncing' );
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
			self.model.revertModel();
		}
	},
} );
export default RecipientGroupCreateForm;